var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-brand',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo-labrador-straits-community-714x200px.png"),"alt":"Labrador Straits Community"}})])}
var staticRenderFns = []

export { render, staticRenderFns }